/**
 * FilterDropdown component export
 */

export { default } from "./FilterDropdownContainer";
